<template>
  <div class="initial_page twoVerification-wrap">
    <div class="main_page verification-success-block">
      <div class="welcome">
        <h1>Member Verified</h1>
        <p>
          Congratulations, Your verification to member dashboard is success.
        </p>
      </div>
      <div class="form">
        <div class="verification-detail two_OTP_verification text-center">
          <div class="verification-icon">
            <img
              src="@/assets/images/checkmark.svg"
              alt="Verification Icon"
              class="img-fluid"
            />
          </div>
          <h2>Verification Success</h2>
          <p>
            Your verification to member dashboard is success <br />
            now you can login to your account
          </p>
          <div class="action-btn">
            <button class="main-primary-btn" @click="loginLink">Login</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Helper from "@/resource/Helper";
export default {
  name: "VerificationSuccess",
  methods: {
    loginLink() {
      Helper.resetRegisterMemberAuth();
      this.$router.push({
        name: "Login",
        params:{tempEmail : this.$store.state.memberEmail}
      });
    },
  },
  created() {
    if (!this.$route.params.memberRegistered) {
      this.$router.push({
        name: "SignUp",
      });
    }
  },
};
</script>
<style scoped>
@import "../../assets/css/verification.css";
</style>